module.exports = __webpack_public_path__ + "static/media/create.ca985057.svg";